<template>
    <div>
        <Modal class="printModal" :value="value" @on-visible-change="visibleChange" :mask-closable="false" width="900" :closable="false">
            <div id="PrintArea">
                <table style="border: 1px solid #000; color: #000; font-family: 宋体; padding: 0px 20px" rules="all" width="100%">
                    <tr>
                        <th colspan="5" style="height: 40px; font-size: 20px; lin-height: 40px; font-weight: 400; border: 0">长沙金镂机械科技有限公司</th>
                    </tr>
                    <tr>
                        <th colspan="5" style="height: 40px; font-size: 20px; lin-height: 40px; border: 0">不合格品处理单</th>
                    </tr>
                    <tr>
                        <td colspan="3" style="border: 0; height: 30px; lin-height: 30px; padding-left: 10px">记录编号：{{ initData.recordNumber }}</td>
                        <td colspan="2" style="border: 0; height: 30px; lin-height: 30px; padding-left: 10px">表单编号：{{ initData.formNumber }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">类型</td>
                        <td colspan="4" style="height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">
                            <span v-for="productType in list.productTypeList" :key="productType.value" style="margin: 0 10px">
                                <input type="checkbox" v-model="form.productType" :value="productType.value" disabled class="check" :style="{ verticalAlign: 'middle', marginRight: '5px', backgroundColor: 'red' }" />
                                {{ productType.name }}
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">物料名称</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">规格/型号</td>
                        <td colspan="2" style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">图号/金蝶物料编码</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">报告部门</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.materialName }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.productSpecification }}</td>
                        <td colspan="2" style="hheight: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.materialCode }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.reportDepartment }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">发生时间</td>
                        <td style="height: 30px; width: 100px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">责任单位/部门</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">责任人</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">批次数量</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">不合格数量</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.occurrenceTimeText }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.accountabilityUnit }}</td>
                        <td style="hheight: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.accountabilityUser }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.batchCount }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.unacceptedCount }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">不良类别</td>
                        <td colspan="4" style="height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.undesirableCategoryText }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">不合格情况描述</td>
                        <td colspan="4" style="height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.unacceptedDescribe }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">填写人</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.writtenUser }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">品质主管确认</td>
                        <td colspan="2" style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.qualitySupervisor }}</td>
                    </tr>
                    <!-- 临时处理方案 -->
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">临时处理方案</td>
                        <td style="width: 240px; height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.temporaryDisposePlan }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">会签</td>
                        <td colspan="2">
                            <table rules="all" width="100%">
                                <tr v-for="(signDepartment, index) in list.signDepartments" :key="index" v-show="signDepartment === '工艺部'">
                                    <td style="height: 30px; width: 60px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{ signDepartment }}</td>
                                    <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">
                                        <span>
                                            <span style="margin-right: 5px">{{ initData.temporaryDisposePlanUser }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr v-for="(signDepartment, index) in list.signDepartments" :key="index" v-show="signDepartment !== '工艺部'">
                                    <td style="height: 30px; width: 60px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{ signDepartment }}</td>
                                    <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">
                                        <span v-for="item in initData.signRecordDtos" :key="item">
                                            <span style="margin-right: 5px">{{ item.signDepartment === signDepartment ? item.departmentHeadUserName : '' }}</span>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <!-- 处置结论 -->
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">处置结论</td>
                        <td colspan="4">
                            <table rules="all" width="100%">
                                <tr v-for="(value, key, index) in list.disposeConclusionKeyValueDic" :key="index" v-show="key !== '其他'">
                                    <template v-if="initData.productType_Text === key">
                                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{ key }}</td>
                                        <td colspan="3" style="height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">
                                            <span style="margin: 0 10px" v-for="(item, index) in value" :key="index">
                                                <input type="checkbox" v-model="form.dispose" :value="item.value" disabled style="vertical-align: middle; margin-right: 5px" />
                                                {{ item.name }}
                                            </span>
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">{{ key }}</td>
                                        <td colspan="3" style="height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">
                                            <span style="margin: 0 10px" v-for="(item, index) in value" :key="index">
                                                <input type="checkbox" disabled style="vertical-align: middle; margin-right: 5px" />
                                                {{ item.name }}
                                            </span>
                                        </td>
                                    </template>
                                </tr>
                                <tr>
                                    <td style="height: 30px; width: 100px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">其他处理</td>
                                    <td colspan="3" style="height: 30px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.disposeConclusionDescribe }}</td>
                                </tr>
                                <tr>
                                    <td style="height: 30px; width: 100px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">责任人</td>
                                    <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.responsibilityDepartmentUserName }}</td>
                                    <td style="height: 30px; width: 100px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">日期</td>
                                    <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.disposeConclusionSubmitTimeText }}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                    <!-- 原因分析改善对策 -->
                    <tr>
                        <td style="height: 60px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">原因分析</td>
                        <td colspan="4" style="height: 60px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.causeAnalysis }}</td>
                    </tr>
                    <tr>
                        <td style="height: 60px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">改善对策</td>
                        <td colspan="4" style="height: 60px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.improveCountermeasure }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">填写人</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.improveCountermeasureWrittenUser }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">日期</td>
                        <td colspan="2" style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.improveCountermeasureWrittenDateText }}</td>
                    </tr>
                    <!-- 跟踪验证 -->
                    <tr>
                        <td style="height: 60px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">跟踪验证</td>
                        <td colspan="4" style="height: 60px; text-align: left; padding-left: 5px; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.trackingVerification }}</td>
                    </tr>
                    <tr>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">验证人</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.trackingVerificationWrittenUser }}</td>
                        <td style="height: 30px; text-align: center; font-size: 12px; white-space: nowrap; border: 1px solid #000">日期</td>
                        <td colspan="2" style="height: 30px; text-align: center; font-size: 12px; color: #000; border: 1px solid #000">{{ initData.trackingVerificationWrittenDateText }}</td>
                    </tr>
                </table>
            </div>
            <div slot="footer">
                <Button @click="cancel" class="close-btn">取消</Button>
                <Button v-print="printObj" type="primary" class="close-btn">打印</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initData: {},
            list: {
                disposeConclusionKeyValueDic: {},
                productTypeList: [],
                signDepartments: [],
            },
            form: {
                productType: [],
                dispose: [],
            },
            printObj: {
                id: 'PrintArea',
                // popTitle: "长沙金镂机械科技有限公司",
                // extraHead: '打印',
                // previewTitle:'长沙金镂机械科技有限公司',
                // previewPrintBtnLabel: '预览结束，开始打印',
                extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
                openCallback(vue) {},
                closeCallback(vue) {},
            },
        };
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        infoData: {
            type: Number,
            required: true,
        },
    },
    mounted() {
        this.getInit();
    },
    methods: {
        async getInit() {
            this.$Spin.show();
            const data = await this.$Ajax.get(`/api/services/app/UnacceptedProductProcessOrder/GetPrintData?id=${this.infoData}`);
            this.list.signDepartments = data.data.result.signDepartments;
            this.list.productTypeList = data.data.result.productTypeList;
            this.list.disposeConclusionKeyValueDic = data.data.result.disposeConclusionKeyValueDic;
            this.initData = data.data.result.unacceptedProductProcessOrderDto;
            this.form.productType.push(this.initData.productType);
            this.form.dispose.push(this.initData.disposeConclusion);
            this.$Spin.hide();
        },
        visibleChange(value) {
            if (!false) {
                this.$emit('succesConfirm', value);
            }
        },
        cancel() {
            this.$emit('succesConfirm', false);
        },
    },
};
</script>

<style lang="less" scoped>
@media print {
    /*最外层打印节点*/
    #PrintArea {
        display: block;
        height: auto;
        overflow: hidden;
    }
}

/deep/.ivu-modal-header-inner {
    font-size: 20px;
    text-align: center;
}

.printModal /deep/ .ivu-modal {
    top: 0;
}
.ivu-modal-footer > div {
    text-align: center;
}

// checkbox禁用checked样式修改
input[type='checkbox'] {
    width: 12px;
    height: 12px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 12px;
    position: relative;
}

input[type='checkbox']::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    background: #fff;
    width: 100%;
    height: 100%;
    border: 1px solid #cacdcf;
}

input[type='checkbox']:checked::before {
    content: '\2713';
    background-color: #000;
    color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border: 1px solid #000;
    font-size: 12px;
    font-weight: bold;
}
</style>
